import React from "react";
import PropTypes from "prop-types";
import * as Components from "./styles";
import NoticiaCard from "../../../NoticiaCard/Basico";
import Button from "../../../Buttons/Button";

function MaisRecentes(props) {
  const noticias = props.noticias;
  return (
    <Components.Sessao>
      <Components.Container>
        <p>Noticias mais recentes</p>
        <Components.Wrapper>
          {noticias?.map((noticia) => {
            return (
              <NoticiaCard
                imgUrl={noticia.noticia_img_path}
                titulo={noticia.titulo}
                tagCategoria={noticia.categorias}
                textPrevia={noticia.previa_texto}
                data={noticia.data_de_publicacao}
                toUrl={`/noticias/${noticia.id}`}
              />
            );
          })}
        </Components.Wrapper>

        <Components.ButtonLink to="/noticias">
          <Button>mais noticias</Button>
        </Components.ButtonLink>
      </Components.Container>
    </Components.Sessao>
  );
}

MaisRecentes.propTypes = {
  noticias: PropTypes.object,
};

export default MaisRecentes;
